import { Wrapper } from "../styles/SelectorBox.styled";

export default function SelectorBoxFieldView({
    orderItemCount,
    holdItemCount,
    onActionRouteToPage,
}) {
    return (
        <Wrapper>
            <div className='title'>미출고 데이터 확인</div>
            <div>
                <div className='button-box'>
                    <button
                        type='button'
                        className='button-el'
                        onClick={() => onActionRouteToPage('/erp/collection/order')}
                    >
                        <div className='button-inner-text'>
                            <div>주문확인</div>
                            <div style={{ color: '#ff4060', minWidth: '50px' }}>{orderItemCount ?? '-'}건 </div>
                        </div>
                    </button>
                </div>
                <div className='button-box'>
                    <button
                        type='button'
                        className='button-el'
                        onClick={() => onActionRouteToPage('/erp/collection/hold')}
                    >
                        <div className='button-inner-text'>
                            <div>보류데이터</div>
                            <div style={{ color: '#ff4060', minWidth: '50px' }}>{holdItemCount ?? '-'}건</div>
                        </div>
                    </button>
                </div>
            </div>
        </Wrapper>
    )
}